import { createSelector } from 'reselect'
import { entitySelector } from 'containers/Entity/selectors'
import * as R from 'ramda'
import P from 'helpers/predicates'

const countSelector = state => state.admin.userSelection.count
const pageSizeSelector = state => state.admin.userSelection.pageSize
const currentPageSelector = state => state.admin.userSelection.currentPage
const siteListSelector = state => state.admin.userSelection.users
const searchValueSelector = state => state.admin.userSelection.search

const sliceAndMapRefsToEntities = R.curry(
  (start, end, entities) => R.compose(
    R.map((id) => entities.users[id]),
    R.slice(start, end)
  )
)

const mapEnabledIndexes = R.compose(
  R.filter(P.isNotNil),
  R.addIndex(R.map)(({ enable }, index) => enable
    ? index
    : null
))

const usersSelector = createSelector(
  currentPageSelector,
  pageSizeSelector,
  siteListSelector,
  entitySelector,
  (page, size, siteRefs, entities) => {
    // slice range
    const start = (page - 1) * size
    const end = (page) * size
    return sliceAndMapRefsToEntities(start, end, entities)(siteRefs)
  }
)

const pageTotalSelector = createSelector(
  countSelector,
  pageSizeSelector,
  R.compose(
    Math.ceil,
    R.divide
  )
)

const selectedUsersSelector = createSelector(usersSelector, mapEnabledIndexes)

const isFirstPageSelector = createSelector(
  currentPageSelector,
  R.equals(1)
)

const isLastPageSelector = createSelector(
  currentPageSelector,
  pageTotalSelector,
  R.equals
)

export {
  pageTotalSelector,
  countSelector,
  pageSizeSelector,
  currentPageSelector,
  selectedUsersSelector,
  usersSelector,
  isFirstPageSelector,
  isLastPageSelector,
  searchValueSelector,
}
